import {NgModule} from '@angular/core';
import {WhiteTooltipDirective} from '@src/app/directives/whiteTooltip/white-tooltip.directive';

@NgModule({
  declarations: [WhiteTooltipDirective],
  exports: [WhiteTooltipDirective],
})
export class WhiteTooltipModule {

}
